import React from 'react'

function SiteinspectionInfo() {
  return (
    <div>site_inspection_info</div>
  )
}

export default SiteinspectionInfo